export function getErrorAsString(error?: unknown) {
  if (!error) {
    return "";
  }

  if (error instanceof Error) {
    return `Error name: ${error.name}. Error message: ${error.message}. Error stack: ${error.stack}`;
  }

  return JSON.stringify(error);
}
